export default "__VITE_ASSET__XBtr8bsO__"